import Button from "@mui/material/Button";

interface ClearFiltersButtonProps {
  isActive: boolean;
  onClick: () => void;
}

/** A filter side panel's "Clear filters" button, at its foot; disabled while no filter is applied. */
export const ClearFiltersButton = (props: ClearFiltersButtonProps) => {
  const { isActive, onClick } = props;

  return (
    <Button
      color="inherit"
      disabled={!isActive}
      fullWidth
      onClick={onClick}
      sx={{
        borderColor: "divider",
        mt: "auto",
      }}
      variant="outlined"
    >
      Clear filters
    </Button>
  );
};
